import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useTranslation } from '@lt/localization';
import { getIsHotelOnly, getIsMobile } from 'src/store/view/selectors';
import SearcherTimer from '../../components/Searcher/SearcherTimer';
import {
  getSearcherLastUpdated,
  getSearcherState,
  getHasOffersForCurrentDate,
} from '../../store/selectors/searcher';
import { SEARCHER_STATE } from '../../store/constants/searcher';
import { getRooms } from '../../store/selectors/rooms';
import styles from './searcher.module.css';

const SearcherStatus = ({
  hasOffers,
  hasOffersForCurrentDate,
  state,
  lastUpdated,
  isHotelOnly,
}) => {
  const { t } = useTranslation();
  return (
    <div className={styles.searcherStatusContainer}>
      {state === SEARCHER_STATE.FETCHING && !hasOffers && (
        <span>
          {t('hotel.searcherStatus.noOffers', {
            context: isHotelOnly ? 'hotel' : 'package',
          })}
        </span>
      )}
      {state === SEARCHER_STATE.FETCHING && hasOffers && (
        <span>
          {t('hotel.searcherStatus.hasOffers', {
            context: isHotelOnly ? 'hotel' : 'package',
          })}
        </span>
      )}
      {state === SEARCHER_STATE.COMPLETED && hasOffersForCurrentDate && (
        <SearcherTimer lastUpdated={lastUpdated} />
      )}
    </div>
  );
};

SearcherStatus.propTypes = {
  state: PropTypes.oneOf(Object.values(SEARCHER_STATE)).isRequired,
  lastUpdated: PropTypes.number,
  hasOffers: PropTypes.bool.isRequired,
  hasOffersForCurrentDate: PropTypes.bool.isRequired,
};

SearcherStatus.defaultProps = {
  lastUpdated: null,
};

const mapStateToProps = (state) => ({
  lastUpdated: getSearcherLastUpdated(state),
  state: getSearcherState(state),
  hasOffers: Boolean(getRooms(state).length),
  hasOffersForCurrentDate: getHasOffersForCurrentDate(state),
  isMobile: getIsMobile(state),
  isHotelOnly: getIsHotelOnly(state),
});

export default connect(mapStateToProps)(SearcherStatus);
